import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Box, Heading, Text, VStack} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Protect Your Cover Component
 * Displays KingGuard protection option for complex products.
 * Visibility is controlled by the kingGuardDisabled custom attribute.
 *
 * @param {object} props
 * @param {object} props.product - Product object with custom attributes
 * @returns {React.ReactNode|null}
 */
export function ProtectYourCover({product}) {
  const intl = useIntl();

  // Check if KingGuard is disabled for this product
  // kingGuardDisabled: Boolean – to determine if KingGuard is applicable to be variation product
  // This will be at the variation product level while fabric or leather will determine the value
  const isKingGuardDisabled = product?.kingGuardDisabled === true;

  // Don't render the component if KingGuard is disabled
  if (isKingGuardDisabled) {
    return null;
  }

  return (
    <Box borderColor="gray.200" borderRadius="md" borderWidth={1} padding={4}>
      <VStack alignItems="stretch" spacing={3}>
        <Heading as="h4" fontSize="xl">
          {intl.formatMessage({
            defaultMessage: 'Protect Your Cover',
            id: 'product_view.protect_your_cover.title',
          })}
        </Heading>

        <Text color="gray.700" fontSize="md">
          {intl.formatMessage({
            defaultMessage: 'Add KingGuard protection to keep your furniture looking its best.',
            id: 'product_view.protect_your_cover.description',
          })}
        </Text>

        {/* TODO: Add KingGuard product option selection UI */}
        <Box>
          <Text fontSize="sm" fontStyle="italic">
            {intl.formatMessage({
              defaultMessage: 'KingGuard option selection coming soon',
              id: 'product_view.protect_your_cover.coming_soon',
            })}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
}

ProtectYourCover.propTypes = {
  product: PropTypes.object,
};
